import {
  createPrelaunchCompanyPaymentDetails,
  editPublicPrelaunchCompanyPaymentDetail,
  getPublicPrelaunchCompanyPaymentDetail,
} from '../../../../api/prelaunchOrganizationFormsApi'
import PaymentDetailForm from '../../../../components/common/payment-detail-form'
import translate from '../../../../i18n'
import { PrelaunchCompanyPaymentDetailFormValues } from '../../../prelaunch-organization-forms-container/share-types'
import { PageHeader } from '@ant-design/pro-components'
import { notification, Space } from 'antd'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

const prelaunchPaymentDetailForm = () => {
  const navigate = useNavigate()
  const params = useParams()
  const [uniqueId] = useState<string | undefined>(params?.uniqueId)
  const [organizationName] = useState<string | undefined>(params?.organizationName)
  const [paymentDetailId] = useState<string | undefined>(params?.paymentDetailId)
  const [formData, setFormData] = useState<PrelaunchCompanyPaymentDetailFormValues>()
  const { pathname } = useLocation()
  const isPublicEdit = pathname.endsWith('/edit')

  useEffect(() => {
    if (uniqueId && paymentDetailId && isPublicEdit) {
      getPublicPrelaunchCompanyPaymentDetail(uniqueId, paymentDetailId).then(setFormData)
    }
  }, [isPublicEdit, paymentDetailId, uniqueId])

  const onFinish = (values: PrelaunchCompanyPaymentDetailFormValues) => {
    if (!uniqueId) {
      return
    }

    const request =
      paymentDetailId && isPublicEdit
        ? editPublicPrelaunchCompanyPaymentDetail(uniqueId, paymentDetailId, values)
        : createPrelaunchCompanyPaymentDetails({
            ...values,
            uniqueId: uniqueId,
          })

    request
      .then(() => {
        notification.success({
          title: isPublicEdit
            ? '修改对公收款帐户详情成功'
            : translate('addCompanyPaymentDetail.success'),
        })
        navigate(-1)
      })
      .catch(err => {
        notification.error({
          title: isPublicEdit
            ? '修改对公收款帐户详情失败'
            : translate('addCompanyPaymentDetail.error'),
          description: err?.message || translate('networkError'),
        })
      })
  }

  const onBack = () => {
    navigate(-1)
  }
  return (
    <Space orientation="vertical" style={{ width: '100%' }}>
      <PageHeader
        className="site-page-header"
        onBack={onBack}
        title={organizationName}
        subTitle={translate('addCompanyPaymentDetail')}
      />
      <PaymentDetailForm onFinish={onFinish} formData={formData} />
    </Space>
  )
}

export default prelaunchPaymentDetailForm
